export const getShowingProductsCount = (
  page: number,
  pageSize: number,
  totalCount: number,
): string => {
  return page * pageSize > totalCount
    ? `${totalCount}`
    : `${(page - 1) * pageSize + 1} - ${page * pageSize}`;
};
